import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import EventsList from "@/pages/EventsList";
import EventDetail from "@/pages/EventDetail";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Support from "@/pages/Support";
import Accounting from "@/pages/Accounting";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children, adminOnly }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-[var(--text-2)]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/events" element={<Protected><EventsList /></Protected>} />
      <Route path="/events/:id" element={<Protected><EventDetail /></Protected>} />
      <Route path="/accounting" element={<Protected><Accounting mode="overview" /></Protected>} />
      <Route path="/accounting/budgeting" element={<Protected><Accounting mode="budgeting" /></Protected>} />
      <Route path="/accounting/costs" element={<Protected><Accounting mode="costs" /></Protected>} />
      <Route path="/accounting/sales" element={<Protected><Accounting mode="sales" /></Protected>} />
      <Route path="/accounting/projections" element={<Protected><Accounting mode="projections" /></Protected>} />
      <Route path="/admin/users" element={<Protected adminOnly><Users /></Protected>} />
      <Route path="/admin/settings" element={<Protected adminOnly><Settings /></Protected>} />
      <Route path="/support" element={<Protected><Support /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
